import { useEffect, useState } from 'react';

const DEFAULT_TOTAL_HITS_UPPER_BOUND = {
  total_hits_upper_bound: 10_000,
};

export const useTotalHitsUpperBound = (): number => {
  const [totalHits, setTotalHits] = useState(DEFAULT_TOTAL_HITS_UPPER_BOUND.total_hits_upper_bound);

  useEffect(() => {
    const { total_hits_upper_bound: totalHitsUpperBound } =
      window.settings?.recordings ?? DEFAULT_TOTAL_HITS_UPPER_BOUND;

    setTotalHits(totalHitsUpperBound);
  }, []);

  return totalHits;
};
